<template>
  <main class="errorPage">
    <div class="container-fluid">
      <div class="ajout-container">
        <div class="row">
          <div class="col-md-12">
            <img src="../assets/image403.png" class="img-fluid"/>
            <p>vous n'êtes pas autorisé à accéder à ce serveur</p>
            <div class="col-12 buttons">
                <router-link
                  :to="{ name: 'dashboard' }"
                  class="btn btn-primary button"
                >
                  Dashboard
                </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "ErrorPage403",
};
</script>
